import FeaturesContainer from './FeaturesContainer'

const RealTimeLocation = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'real-time-location'} nextUrl={'place-alerts'} pageEvent={'onboardingRealTimeLocation'} clickEvent={'onboardingRealTimeLocationSubmitted'} />
};

export default RealTimeLocation
